import { AxiosResponse } from "axios"

import HttpService, { StreamEvents } from "@services/http.service"
import QueryAttachment from "@store/search/query-attachment"
import { DefaultSuccessResponse } from "@services/common/types"

export type CreateChatAttachmentResponse = {
  id: string
  sessionId: string
}

const unwrapAttachmentResponse = (
  response: { data: DefaultSuccessResponse<CreateChatAttachmentResponse> | CreateChatAttachmentResponse }
): CreateChatAttachmentResponse => {
  const body = response.data as DefaultSuccessResponse<CreateChatAttachmentResponse>
  const payload = body?.data ?? (response.data as CreateChatAttachmentResponse)

  if (!payload?.id || !payload?.sessionId) {
    throw new Error("Invalid attachment upload response")
  }

  return payload
}

class ChatAPI extends HttpService {
  search = (
    params: {
      query: string
      avatar: string
      sessionId: string
      productSolutionId: string
    },
    events: StreamEvents
  ): Promise<void> => {
    return this.postJSONStream("ts/chat/query", params, events)
  }

  createAttachment = async (params: {
    attachment: QueryAttachment
    sessionId?: string
  }): Promise<CreateChatAttachmentResponse> => {
    const data = new FormData()
    data.set("attachment", params.attachment.file)

    if (params.sessionId) {
      data.set("sessionId", params.sessionId)
    }

    const response = await this.post("ts/chat/attachment", data, true)

    return unwrapAttachmentResponse(response)
  }

  deleteAttachment = (params: {
    id: string
    sessionId: string
  }): Promise<AxiosResponse> => {
    return this.delete("ts/chat/attachment", undefined, true, params)
  }
}

export default new ChatAPI()
